import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`

export const SubTitleContainer = styled.div``

export const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
`

export const SubTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  text-align: center;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`

export const ButtonBack = styled.div`
  color: #c6016b;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c6016b;
  color: white;
  font-weight: bold;
  border: none;
  padding: 14px 22px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
`
